import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  body: Yup.string().when('image', {
    is: (image: string) => !image,
    then: Yup.string().required('field.error.required'),
  }),
})
